<template>
  <div>
    <v-container grid-list-xl class="word-wrap mt-5">
      <v-layout row wrap justify-center mt-0 pb-5>
        <v-flex xs12 md8>
          <v-layout class="ml-1 mr-0 my-2">
            <h4 class="font-weight-bold defaultColor--text">
              {{ $t("title.notifications") }}
            </h4>
            <v-spacer />
            <v-btn
              color="defaultColor"
              class="white--text text-capitalize"
              text
              :loading="readAllNotificationLoading"
              rounded
              @click="readAllNotification()"
            >
              {{ $t("buttons.markAsRead") }}
            </v-btn>
          </v-layout>
          <v-card class="homeFeedContainer" flat>
            <v-tabs
              v-model="tab"
              background-color="transparent"
              grow
              color="defaultColor"
              style="border-bottom: 1px solid grey !important"
            >
              <v-tab
                v-for="tabItem in tabItems"
                :key="tabItem.data"
                @click="clickTab()"
              >
                {{ tabItem.title }}
              </v-tab>
            </v-tabs>

            <v-tabs-items
              v-model="tab"
              style="overflow-y: scroll; height: calc(100vh - 290px); background-color: rgba(0,0,0,0) !important"
            >
              <v-tab-item v-for="tabItem in tabItems" :key="tabItem.data">
                <loading-progress :status="loadingList[tabItem.data]" />
                <v-list
                  class="pl-1 mx-4"
                  style="background-color: rgba(0,0,0,0)"
                >
                  <!-- aylavblog -->
                  <template v-for="(item, index) in data[tabItem.data]">
                    <v-divider :inset="false" v-if="index != 0"></v-divider>
                    <v-list-item
                      @click="seenNotification(item, index)"
                      style="cursor: pointer; background-color: rgba(0,0,0,0)"
                      :class="
                        !item.IsSeen
                          ? 'defaultColorLightThree py-1 rounded-lg my-2'
                          : 'py-1 my-2'
                      "
                    >
                      <v-list-item-avatar>
                        <v-img :src="item.User.Avatar"></v-img>
                      </v-list-item-avatar>

                      <v-list-item-content v-text="item.Description">
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-list-item-action-text>
                          {{ moment(item.CreatedAt).locale("tr").fromNow() }}
                        </v-list-item-action-text>

                        <!-- <v-icon v-if="!item.IsSeen" small color="defaultColor">
                          mdi-checkbox-blank-circle
                        </v-icon> -->
                      </v-list-item-action>
                    </v-list-item>
                  </template>

                  <div
                    class="text-center"
                    v-if="
                      !moreButtonHidden[tabItem.data] &&
                      !loadingList[tabItem.data]
                    "
                  >
                    <v-btn
                      text
                      color="primary"
                      @click="loadMore()"
                      :loading="moreButtonLoading"
                      class="text-capitalize mt-2"
                    >
                      {{ $t("buttons.more") }}
                    </v-btn>
                  </div>
                </v-list>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import NotificationService from "@/services/NotificationService";
import UserListItem from "../../components/Users/UserListItem.vue";
import LoadingProgress from "../../components/General/LoadingProgress.vue";
import DescriptionAlert from "../../components/General/DescriptionAlert.vue";
import { mapActions } from "vuex";

export default {
  data: function () {
    {
      return {
        tab: 0,

        tabItems: [
          { title: this.$t("tabs.ayLavBlog"), data: "ayLavBlogData" },
          { title: this.$t("tabs.batAcademy"), data: "batAcademyData" },
          { title: this.$t("tabs.news"), data: "newsData" },
        ],

        data: {
          ayLavBlogData: [],
          batAcademyData: [],
          newsData: [],
        },

        moreButtonHidden: {
          ayLavBlogData: false,
          batAcademyData: false,
          newsData: false,
        },

        loadingList: {
          ayLavBlogData: false,
          batAcademyData: false,
          newsData: false,
        },

        moreButtonLoading: false,

        pageSize: 15,
        pageNumber: {
          bsp: 1,
          academy: 1,
          news: 1,
        },

        readAllNotificationLoading: false,
      };
    }
  },
  components: {
    UserListItem,
    LoadingProgress,
    DescriptionAlert,
  },
  methods: {
    setNotificationData() {
      if (this.$store.state.notificationItems.length != 0) {
        this.data.ayLavBlogData = this.$store.state.notificationItems;
      } else {
        setTimeout(() => {
          this.data.ayLavBlogData = this.$store.state.notificationItems;
        }, 2000);
      }
    },

    setLoading(status) {
      switch (this.tab) {
        case 0:
          this.loadingList.ayLavBlogData = status;
          break;
        case 1:
          this.loadingList.batAcademyData = status;
          break;
        case 2:
          this.loadingList.newsData = status;
          break;
      }
    },

    seenNotification(item, index) {
      if (item.Data) {
        notificationNavigate(JSON.parse(item.Data));
      }
      if (!item.IsSeen) {
        this.readNotifications(item.Id)
          .then(() => {
            //this.data.ayLavBlogData[index].IsSeen = true;
          })
          .catch((err) => {
            showError(err);
          });
      }
    },

    loadMore() {
      switch (this.tab) {
        case 0:
          this.pageNumber.bsp = ++this.pageNumber.bsp;
          this.getData();
          break;
        case 1:
          this.pageNumber.academy = ++this.pageNumber.academy;
          this.getData();
          break;
        case 2:
          this.pageNumber.news = ++this.pageNumber.news;
          this.getData();
          break;
      }
    },

    getData() {
      switch (this.tab) {
        case 0:
          this.getNotification("Individual");
          break;
        case 1:
          this.getNotification("Academy");
          break;
        case 2:
          this.getNotification("Corporate");
          break;
      }
    },

    getNotification(type = "Individual") {
      let page = this.getPageNumber();
      if (page != 1) this.moreButtonLoading = true;
      if (page == 1) this.setLoading(true);
      let target = this.$store.state.user.Id;
      NotificationService.getNotification(page, this.pageSize, target, type)
        .then((res) => {
          switch (this.tab) {
            case 0:
              this.setDataBsp(res.data);
              break;
            case 1:
              this.setDataAcademy(res.data);
              break;
            case 2:
              this.setDataNews(res.data);
              break;
          }
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.setLoading(false);
          this.moreButtonLoading = false;
        });
    },

    setDataBsp(data) {
      const notifications = data.Result;
      let oldData = this.data.ayLavBlogData;
      let _data = [];
      if (this.pageNumber.bsp !== 1) {
        _data = [...oldData, ...notifications];
      } else {
        _data = notifications;
      }
      this.data.ayLavBlogData = _data;
      if (data.length <= 0) {
        this.moreButtonHidden.ayLavBlogData = true;
      }
    },

    setDataAcademy(data) {
      const notifications = data.Result;
      let oldData = this.data.batAcademyData;
      let _data = [];
      if (this.pageNumber.academy !== 1) {
        _data = [...oldData, ...notifications];
      } else {
        _data = notifications;
      }
      this.data.batAcademyData = _data;
      if (data.length <= 0) {
        this.moreButtonHidden.batAcademyData = true;
      }
    },

    setDataNews(data) {
      const notifications = data.Result;
      let oldData = this.data.newsData;
      let _data = [];
      if (this.pageNumber.news !== 1) {
        _data = [...oldData, ...notifications];
      } else {
        _data = notifications;
      }
      this.data.newsData = _data;
      if (data.length <= 0) {
        this.moreButtonHidden.newsData = true;
      }
    },

    getPageNumber() {
      switch (this.tab) {
        case 0:
          return this.pageNumber.bsp;
        case 1:
          return this.pageNumber.academy;
        case 2:
          return this.pageNumber.news;
      }
    },

    clickTab() {
      setTimeout(() => {
        let page = this.getPageNumber();
        switch (this.tab) {
          case 0:
            if (page == 1) this.getNotification("Individual");
            break;
          case 1:
            if (page == 1) this.getNotification("Academy");
            break;
          case 2:
            if (page == 1) this.getNotification("Corporate");
            break;
        }
      }, 200);
    },

    readAllNotification() {
      this.readAllNotificationLoading = true;

      let type = "Individual";
      switch (this.tab) {
        case 0:
          type = "Individual";
          break;
        case 1:
          type = "Academy";
          break;
        case 2:
          type = "Corporate";
          break;
      }

      NotificationService.readAllNotification(type)
        .then((res) => {
          this.readAllNotifications();
          switch (this.tab) {
            case 0:
              this.data.ayLavBlogData = [];
              this.pageNumber.bsp = 1;
              this.getData();
              break;
            case 1:
              this.data.batAcademyData = [];
              this.pageNumber.academy = 1;
              this.getData();
              break;
            case 2:
              this.data.newsData = [];
              this.pageNumber.news = 1;
              this.getData();
              break;
          }
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.readAllNotificationLoading = false;
        });
    },

    ...mapActions([
      "readNotifications",
      "getNotifications",
      "readAllNotifications",
    ]),
  },
  computed: {},
  destroyed() {},
  mounted() {
    //this.setNotificationData();
    this.getNotification();
  },
  watch: {},
};
</script>
